<template>
  <div class="live-elements">
    <el-dialog title="实况要素" :visible.sync="params.flag" v-dialogDrag :modal="false" :close-on-click-modal="false"
      :lock-scroll="false" :modal-append-to-body="false" ref="liveFavRef" :before-close="() =>
        params.flag &&
        this.$parent.toggleProductView(this.params.productInfo.code)
        ">
      <div slot="title" class="select-header">
        <span>实况要素</span>
        <span>
          <span v-if="tableData.length > 0" class="update-time">
            更新时间：{{
              $moment(tableData[0].timeLong).format("YYYY-MM-DD HH:mm")
            }}
          </span>
        </span>
      </div>
      <div class="content" ref="tableRef">
        <el-table :data="tableData" :max-height="maxHeight" style="width: 100%">
          <el-table-column prop="name" label="项目点位">
            <template slot-scope="scope">
              <div class="cell-name">
                <img src="@/assets/images/定位-蓝.png" alt="" />
                <span>{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="temp" label="温度(℃)" min-width="45">
            <template slot-scope="scope">
              {{
                [9999, -999.9].includes(scope.row.temp) ? "--" : scope.row.temp
              }}
            </template>
          </el-table-column>
          <el-table-column prop="winds" label="平均风(m/s)" min-width="45">
            <template slot-scope="scope">
              {{
                [9999, -999.9].includes(scope.row.winds)
                  ? "--"
                  : scope.row.winds
              }}
            </template>
          </el-table-column>
          <el-table-column prop="windd" label="风向" min-width="55">
            <template slot-scope="scope">
              {{
                [9999, -999.9].includes(scope.row.windd)
                  ? "--"
                  : scope.row.windd
              }}
            </template>
          </el-table-column>
          <el-table-column prop="rh" label="湿度(%)" min-width="45">
            <template slot-scope="scope">
              {{ [9999, -999.9].includes(scope.row.rh) ? "--" : scope.row.rh }}
            </template>
          </el-table-column>
          <el-table-column prop="hourrf" label="1小时雨量(mm)" min-width="55">
            <template slot-scope="scope">
              {{
                [9999, -999.9].includes(scope.row.hourrf)
                  ? "--"
                  : scope.row.hourrf
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { handleDownload } from "@/utils/exportFile";
import { mapState } from "vuex";
import { apiData } from "@/api/index";
import { findWind } from "@/utils/tool.js";
export default {
  props: ["params"],
  data() {
    return {
      tableData: [],
      maxHeight: 200,
    };
  },
  computed: {
    ...mapState("home", ["objsList", "unitPointDataResult", "activeCountyId"]),
  },
  watch: {
    "params.flag": {
      handler(flag) {
        flag && this.setZindex();
        this.$nextTick(() => {
          this.maxHeight = this.$refs.tableRef.offsetHeight;
          console.log(this.maxHeight);
        });
      },
      immediate: true,
    },
  },
  mounted() {
    this.getGiftLive();
  },
  methods: {
    async getGiftLive() {
      this.tableData = [];
      const wheatherLiveResult = await apiData.queryWheatherLiveData(this.activeCountyId);
      // 项目点位
      this.objsList.forEach(async (point, index) => {
        const tqskDateResult = wheatherLiveResult.data;
        tqskDateResult.temp = (tqskDateResult.t).toFixed(1);
        tqskDateResult.p = (tqskDateResult.p).toFixed(1);
        tqskDateResult.winds = tqskDateResult.wd2df;
        tqskDateResult.windd = tqskDateResult.wd2dd;
        tqskDateResult.timeLong = tqskDateResult.ddatetime;
        tqskDateResult.winds = tqskDateResult.wd2df;
        const pointObj = { ...point, ...tqskDateResult };
        pointObj.windd = findWind(pointObj.windd);
        this.tableData.push(pointObj);
      });
      // 数据点位
      this.unitPointDataResult.forEach((point) => {
        point.name = point.pname;
        point.temp = point.t;
        point.winds = point.wd2df;
        point.windd = point.wd2dd;
        point.timeLong = point.ddatetime;
        point.winds = point.wd2df;
        const pointObj = { ...point };
        pointObj.windd = findWind(pointObj.windd);
        this.tableData.push(pointObj);
      });
    },
    handleDownload() {
      const filterVal = ["name", "temp", "winds", "windd", "rh", "hourrf"];
      const header = [
        "项目点位",
        "温度",
        "平均风",
        "风向",
        "湿度",
        "1小时雨量",
      ];
      handleDownload(filterVal, this.tableData, header, "实况要素");
    },
    // 设置弹出框的zIndex
    setZindex() {
      this.$nextTick(() => {
        const el = this.$refs.liveFavRef;
        let zIndex = JSON.parse(localStorage.getItem("dialogZIndex"));
        zIndex = zIndex * 1 + 1;
        el.$el.style.zIndex = zIndex;
        localStorage.setItem("dialogZIndex", JSON.stringify(zIndex));
      });
    },
  },
};
</script>
<style lang="less" scoped>
.live-elements {
  pointer-events: none;

  .select-header {
    display: flex;
    justify-content: space-between;
    padding-right: 2.6vw;
    color: #fff;

    span:nth-child(1) {
      font-size: 0.94vw;
      font-weight: 600;
      color: #fff;
    }

    span:nth-child(2) {
      font-size: 0.73vw;
    }
  }
}

.content {
  position: relative;
  flex: 1;
  box-sizing: border-box;

  .el-table {
    background: transparent;
    text-align: center;

    /deep/ tr {
      background: transparent;

      th {
        text-align: center;
        border: 0;
        font-size: 0.88rem;
        font-weight: 600;
        color: #fff;
        background: #3c7cb8;
      }

      td {
        text-align: center;
        font-size: 0.88rem;
        font-weight: 400;
        color: #fff;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }

      .print {
        width: 1.13rem;
        height: 1.13rem;
        background: url("../assets/images/打印.png") no-repeat;
        border: 0;
        cursor: pointer;
        background-size: 1.13rem 1.13rem;
      }

      .image {
        margin: 0.52vw;
        width: 1.09vw;
        cursor: pointer;
      }
    }

    /deep/ tr:hover td {
      background: #3c7cb8 !important;
    }

    .new {
      margin-left: 0.52vw;
      background-color: #f56c6c;
      border-radius: 0.32vw;
      color: #fff;
      display: inline-block;
      font-size: 0.43vw;
      height: 0.94vw;
      line-height: 0.94vw;
      padding: 0.1vw 0.31vw;
      text-align: center;
      white-space: nowrap;
    }

    /deep/.el-table__body-wrapper::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: #273458;
    }

    /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      border-radius: 5px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #1b2230;
    }

    /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
      border-radius: 5px;
      background: #0c4170;
    }

    /deep/.el-table__fixed-right-patch {
      background: #1b3b80;
      border: 0;
    }
  }

  .el-table::before,
  /deep/.el-table__fixed-right::before {
    background: transparent;
  }
}

.cell-name {
  display: flex;
  align-items: center;

  img {
    width: 1.3vw;
    margin-right: 0.26vw;
    vertical-align: center;
  }
}

.info_box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0.58vw 0.68vw;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0vw 0.1vw 0.94vw 0vw rgba(139, 157, 189, 0.35);
  border-radius: 0.52vw;

  .item {
    display: flex;
    justify-content: space-between;
    margin: 5px 0px;
    font-size: 0.73vw;
    line-height: 1.04vw;
    text-align: left;

    .label {
      color: #666666;
    }

    .value {
      width: 3.6vw;
      color: #333333;
      padding-left: 1.04vw;
    }
  }
}

.trangle {
  position: absolute;
  bottom: -1.04vw;
  left: 50%;
  transform: translateX(-50%);
  height: 0vw;
  width: 0vw;
  border-left: 0.26vw solid #000;
  border-right: 0.26vw solid #000;
  border-top: 0.52vw solid #000;
  border-bottom: 0.52vw solid #000;
  border-bottom-color: transparent;
  border-top-color: rgba(255, 255, 255, 0.9);
  border-left-color: transparent;
  border-right-color: transparent;
}

.box .close {
  position: absolute;
  right: 1.25rem;
  top: 0.5vw;
}

.update-time {
  padding-right: 10px;
  font-size: 0.75rem;
  color: #fff;
}

/deep/ .el-dialog__body {
  overflow: hidden;
  margin-bottom: 10px;
}

/deep/.el-dialog__wrapper {
  overflow: hidden;

  .el-dialog {
    width: 76rem;
    pointer-events: auto;
  }
}
</style>
